import { Injectable } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';
import * as fromOrders from './sales.reducer';
import * as SalesSelectors from './sales.selectors';

@Injectable()
export class SalesFacade {
  loaded$ = this.store.pipe(select(SalesSelectors.getSalesOrdersLoaded));
  allOrders$ = this.store.pipe(select(SalesSelectors.getSalesAllOrders));
  selectedOrders$ = this.store.pipe(select(SalesSelectors.getSalesSelected));

  locations$ = this.store.pipe(select(SalesSelectors.getSalesLocations));
  addingOrUpdatingEvent$ = this.store.pipe(
    select(SalesSelectors.getSalesAddingOrUpdatingEvent)
  );

  selectedLocationType$ = this.store.pipe(
    select(SalesSelectors.getSalesLocationType)
  );

  selectedOrderDirection$ = this.store.pipe(
    select(SalesSelectors.getSalesOrderDirection)
  );

  selectedLocationIds$ = this.store.pipe(
    select(SalesSelectors.getSalesSelectedLocationIds)
  );

  selectedCustomerIds$ = this.store.pipe(
    select(SalesSelectors.getSalesSelectedCustomerIds)
  );

  selectedDateRange$ = this.store.pipe(
    select(SalesSelectors.getSalesSelectedDateRange)
  );

  dateRange$ = this.store.pipe(
    select(SalesSelectors.getSalesSelectedLocationIds)
  );

  query$ = this.store.pipe(select(SalesSelectors.getSalesQuery));
  nextPage$ = this.store.pipe(select(SalesSelectors.getSalesNextPage));
  messages$ = this.store.pipe(select(SalesSelectors.saleMessages));
  selectedStatus$ = this.store.pipe(select(SalesSelectors.getSalesStatus));

  constructor(private store: Store<fromOrders.SalesPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
